Vue.component("contact",
    {
        template: "#vue-contact",

        data()
        {
            return {
                emailIsValid       : true,
                emailRepeat        : "",
                emailRepeatOk      : true,
                emailAlreadyExists : false,
                passwordRepeat     : "",
                passwordRepeatOk   : true,
                waitForResponse    : false,
                showPassword       : false,
                states             : null,
                inputPasswordType  : "password"
            };
        },

        watch: {
            showPassword: function(val)
            {
                this.inputPasswordType = val ? "text" : "password";
            }
        },

        computed: {
            ...Vuex.mapGetters(
                {
                    trans:          "getTranslation",
                    getCountryById: "getCountryObjectById"
                }
            ),
            ...Vuex.mapState(
                {
                    pid:                      state => state.assistant.pid,
                    systemContractType:       state => state.assistant.systemContractType,
                    newContact:               state => state.contact.newContact,
                    contact:                  state => state.contact.contact,
                    contactData:              state => state.contact.contactData,
                    billingAddressData:       state => state.contact.billingAddressData,
                    countryIsoCode:           state => state.contact.countryIsoCode,
                    countryName:              state => state.contact.countryName,
                    activeShippingCountries:  state => state.localization.activeShippingCountries,
                    currentShippingCountryId: state => state.localization.currentShippingCountryId
                }
            ),
            escapeRegExp()
            {
                return string =>
                {
                    if (string)
                    {
                        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    }
                    return "";
                };
            },
            canChangeCompanyName()
            {
                return this.systemContractType === "demo";
            }
        },

        ready()
        {
            this.onShippingCountryChange({target:{value:this.currentShippingCountryId}});

            if (this.newContact)
            {
                this.$store.commit("setBillingAddressData",
                    {
                        field: "countryId",
                        value: this.currentShippingCountryId
                    });

            }
            else if (parseInt(this.billingAddressData.countryId) > 0)
            {
                this.onShippingCountryChange({target:{value:this.currentShippingCountryId}});
            }
        },

        methods: {
            ...Vuex.mapMutations(
                [
                    "setCountryDetails",
                    "setContactData",
                    "setBillingAddressData"
                ]
            ),
            ...Vuex.mapActions(
                [
                    "getContract",
                    "getContractUpdate",
                    "saveContact",
                    "updateContactAddress",
                    "checkIfEmailInUse"
                ]
            ),

            /**
             * Navigation between pages
             * @param direction 'next' || 'back'
             */
            navAction(direction)
            {
                this.$emit("nav-action", direction);
            },

            /**
             * On billing address data change
             * @param field
             * @param event
             */
            onBillingInputChange(field, event)
            {
                this.setBillingAddressData(
                    {
                        field: field,
                        value: event.target.value
                    });
            },

            /**
             * On contact data change
             * @param field
             * @param event
             */
            onContactInputChange(field, event)
            {
                this.setContactData(
                    {
                        field: field,
                        value: event.target.value
                    });
            },

            /**
             * Set country details
             * @param event
             */
            onShippingCountryChange(event)
            {
                const country = this.getCountryById(event.target.value);

                this.states = country.states;

                this.setCountryDetails(country);
            },

            /**
             * Validate fields, save contact and get
             * correct contract items and prices
             */
            registerContact()
            {
                if (this.validate())
                {
                    this.waitForResponse = true;

                    this.checkIfEmailInUse().then(response =>
                    {
                        this.emailAlreadyExists = response.inuse;
                        this.emailIsValid = !this.emailAlreadyExists;

                        if (!this.emailAlreadyExists)
                        {
                            this.getContract().then(() =>
                            {
                                this.waitForResponse = false;
                                this.navAction("next");
                            });
                        }
                        else
                        {
                            this.waitForResponse = false;
                        }
                    });
                }
            },

            saveAddress()
            {
                if (this.validateForms())
                {
                    this.waitForResponse = true;

                    this.updateContactAddress().then(() =>
                    {
                        this.getContractUpdate().then(() =>
                        {
                            this.waitForResponse = false;
                            this.navAction("next");
                        });
                    });
                }
            },

            /**
             * Validate all forms and e-mail
             * @returns {boolean|*}
             */
            validate()
            {
                return this.validateForms() && this.validateEmail();
            },

            /**
             * Validate contact forms
             * @returns {boolean}
             */
            validateForms()
            {
                let formsValid = true;

                for (const form of document.querySelectorAll(".contact-form"))
                {
                    if (form instanceof Object)
                    {
                        if (!form.checkValidity())
                        {
                            form.className += " was-validated";
                            formsValid = false;
                        }
                        else
                        {
                            form.className.replace(" was-validated", "");
                        }
                    }
                }
                return formsValid;
            },

            /**
             * Validate e-mail
             * @returns {boolean}
             */
            validateEmail()
            {
                const mailRegEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

                this.emailIsValid = mailRegEx.test(this.billingAddressData.email);

                return this.emailIsValid;
            },

            /**
             * Validate e-mail on change
             */
            runValidateEmail()
            {
                if (!this.emailIsValid)
                {
                    this.emailAlreadyExists = false;
                    this.validateEmail();
                }
            },
            canChangeCompanyName()
            {
                return this.newContact || this.systemContractType === "demo";
            }
        }
    });
